/* eslint-disable no-underscore-dangle */
import React, { useState } from 'react';
import { useQuery } from '@apollo/react-hooks';
import { Jumbotron, Container } from 'reactstrap';
import { CustomerSearch } from '../sav-lovebox/form/customer-search';
import { GET_USER_DATA_PHOTOBOOK } from '../../query/query';
import history from '../../router/history';
import PhotoBookUserData from './user-photobook-data';

const PhotoBookInfo = ({ email }) => {
  const { loading, error, data: { savGetUserDataPhotoBook: userData } = {} } = useQuery(
    GET_USER_DATA_PHOTOBOOK,
    {
      fetchPolicy: 'network-only',
      variables: { email },
    },
  );

  if (loading) {
    return <p>Loading...</p>;
  }
  if (error) {
    return <p>Error</p>;
  }

  return (
    <Container>
      <PhotoBookUserData userData={userData} email={email} />
    </Container>
  );
};

const PhotoBookInfoPage = ({ match: { params: { email: urlEmail = '' } } }) => {
  const [email, setEmail] = useState(urlEmail);

  const updateEmail = (newEmail) => {
    if (newEmail) {
      history.push({
        pathname: `/photobook/${newEmail}`,
      });
      setEmail(newEmail);
    }
  };

  return (
    <Container>
      <Jumbotron className="templates">
        <h3>Photo Book Info</h3>
        <hr className="my-2" />
        <CustomerSearch
          email={email}
          onButtonClick={updateEmail}
        />
        {email && (<PhotoBookInfo email={email} />)}
      </Jumbotron>
    </Container>
  );
};

export default PhotoBookInfoPage;



// WEBPACK FOOTER //
// ./src/components/photobook/photobook-info.js